import { creatorbase, creatorbaseQueries } from '@round/api';
import { useQueries, UseQueryResult } from '@tanstack/react-query';
import { useCallback } from 'react';

const options = creatorbaseQueries.aggregatedAudioStats.options.list;

const combine = (array: (number | undefined)[]): number | undefined => {
    return array.reduce<number | undefined>((acc, value) => {
        if (value !== undefined) {
            return (acc || 0) + value;
        }

        return acc;
    }, undefined);
};

export function useAudioStatsIndicators(songId: number | null | undefined) {
    return useQueries({
        queries: [
            {
                ...options({
                    song_id: songId!,
                    platform: 'tiktok',
                }),
                enabled: !!songId,
            },
            {
                ...options({
                    song_id: songId!,
                    platform: 'instagram',
                }),
                enabled: !!songId,
            },
        ],
        combine: useCallback(
            ([tiktokResults, instagramResults]: UseQueryResult<creatorbase.AggregatedAudioStats>[]) => ({
                data: [
                    {
                        label: 'Total Audios',
                        total: combine([tiktokResults.data?.audio_count, instagramResults.data?.audio_count]),
                        instagram: instagramResults.data?.audio_count,
                        tiktok: tiktokResults.data?.audio_count,
                    },
                    {
                        label: 'Total Video Creations',
                        total: combine([tiktokResults.data?.video_count, instagramResults.data?.video_count]),
                        instagram: instagramResults.data?.video_count,
                        tiktok: tiktokResults.data?.video_count,
                    },
                    {
                        label: 'Creations (last 7 days)',
                        total: combine([
                            tiktokResults.data?.video_count_weekly_change,
                            instagramResults.data?.video_count_weekly_change,
                        ]),
                        instagram: instagramResults.data?.video_count_weekly_change,
                        tiktok: tiktokResults.data?.video_count_weekly_change,
                    },
                    {
                        label: 'Daily Creations',
                        total: combine([
                            tiktokResults.data?.video_count_daily_change,
                            instagramResults.data?.video_count_daily_change,
                        ]),
                        instagram: instagramResults.data?.video_count_daily_change,
                        tiktok: tiktokResults.data?.video_count_daily_change,
                    },
                ],
                isFetching: tiktokResults.isFetching || instagramResults.isFetching,
                isError: tiktokResults.isError || instagramResults.isError,
            }),
            []
        ),
    });
}
